import React, { useContext, useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import DContext from '../../context/DContext';


const AlertBox = (props) => {
    const { variant, data, time } = props;
    const [show, setShow] = useState(true)

    const {
        commonState,
        commonDispatch,
        fun1,
        fun2,

    } = useContext(DContext);

    const { alertArr } = commonState;

    const alertType = [
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark'
    ]

    useEffect(() => {
        console.log("---", alertArr);
        // commonDispatch({ type: "REMOVE_ALERT", payload: null});

    }, [])

    return (
        alertArr.length > 0 && alertArr.map(singleAlert => {
            setTimeout(() => {
                commonDispatch({ type: "REMOVE_ALERT", payload: null });
            }, 3000)

            return (
                <Alert key={singleAlert?.variant} variant={singleAlert?.variant}>
                    {singleAlert?.message}
                </Alert>
            )

        })

    )

}

export default AlertBox